/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bald_Direct_Florian_AmazeInputs */

const en_bald_direct_florian_amaze = /** @type {(inputs: Bald_Direct_Florian_AmazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const de_bald_direct_florian_amaze = /** @type {(inputs: Bald_Direct_Florian_AmazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen`)
};

/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {Bald_Direct_Florian_AmazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bald_direct_florian_amaze = /** @type {((inputs?: Bald_Direct_Florian_AmazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bald_Direct_Florian_AmazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bald_direct_florian_amaze(inputs)
	return de_bald_direct_florian_amaze(inputs)
});